<template>
  <div class="bg w100 font16 paddingtop20 mw100 font12">
    <div class="flex flex-jcbet w80 margincenter minwidth flexnone">
      <div class="brand">
        <img :src="logoblack" alt="术势科技" class="logoblack" />
        <div class="brand-text">
          <div class="brand-name">术势信息科技</div>
          <div class="brand-en">SHUSHI INFORMATION TECH</div>
        </div>
      </div>
      <div style="flex: 1;">
        <div v-for="(item) in skipList" :key="item.name" class="margintop10" style="text-align: center;">
          <el-button type="text" class="font16 mfont14" @click="skip(item.url)">{{ item.name }}</el-button>
        </div>
      </div>
      <div style="flex: 1;">
        <div class="margintop10 mmargintop20">联系我们</div>
        <div v-for="item in informationList" :key="item.msg" class="flex margintop10">
          <img :src="item.icon" alt="" class="icon margincentY" />
          <div class="marginleft msg">{{ item.msg }}</div>
        </div>
      </div>
      <!-- <div>
        <div class="margintop10">扫一扫，关注我们</div>
      </div> -->
    </div>

    <div class="margintop20 textcent">
      技术支持：上海术势信息科技有限公司
    </div>

    <div class="margintop20 textcent fontmsg paddingbot20" style="font-size:10px;cursor: pointer;"
      @click="bottomSkip()">
      Copyright ©上海术势信息科技有限公司 沪ICP备2023012788号
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logoblack: 'https://java-1316167083.cos.ap-shanghai.myqcloud.com/java-1316167083/9a08822bbaeeefb5ba16cb49341e79bc003da1b3fc4582ec81334b272d261058.webp',

      skipList: [
        { name: "首页", url: "/" },
        { name: "关于我们", url: "/partner" },
        { name: "行业案例", url: "/trends" },
        { name: "联系我们", url: "/join" }
      ],

      informationList: [
        {
          msg: "4001100508",
          icon: require("../../public/img/footer/footer_icon.png"),
        },
        {
          msg: "shshushi2025@126.com",
          icon: require("../../public/img/footer/footer_icon2.png"),
        },
        {
          msg: "上海市黄浦区丽园路700号5楼501室D-103单元",
          icon: require("../../public/img/footer/footer_icon3.png"),
        },
      ],
    };
  },

  methods: {
    skip(url) {
      this.$router.push(url);
    },
    bottomSkip() {
      location.href = 'https://beian.miit.gov.cn/'
    }
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: #fff;
}

.bg {
  background-color: #343434;
}

.font16 {
  color: #ffffff;
  font-size: 16px;
}

.fontmsg {
  color: #ffffff;
}

.textcent {
  text-align: center;
}

.icon {
  width: 10px;
}

.flex {
  display: flex;
}

.flex-jcbet {
  justify-content: space-between;
}

.w100 {
  width: 100%;
}

.w60 {
  width: 60%;
}

.minwidth {
  min-width: 1000px;
}

.margincenter {
  margin: 0 auto;
}

.margincentY {
  margin: auto 0;
}

.margintop10 {
  margin-top: 10px;
}

.margintop20 {
  margin-top: 20px;
}

.marginleft {
  margin-left: 10px;
}

.paddingtop20 {
  padding-top: 20px;
}

.brand {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 1.5rem;
  gap: 12px;
}

.logoblack {
  height: 72px;
  width: auto;
  display: block;
  object-fit: contain;
  filter: brightness(1.05);
}

.brand-text {
  text-align: center;
}

.brand-name {
  font-size: 22px;
  font-weight: 600;
  letter-spacing: 0.28em;
  color: #ffffff;
  line-height: 1.2;
  padding-left: 0.28em;
}

.brand-en {
  margin-top: 6px;
  font-size: 11px;
  letter-spacing: 0.35em;
  color: rgba(255, 255, 255, 0.45);
  line-height: 1;
  padding-left: 0.35em;
  text-transform: uppercase;
}

@media screen and (max-width: 750px) {
  .minwidth {
    min-width: 0px;
  }

  .flexnone {
    display: block;
  }

  .mw100 {
    width: 100vw;
  }

  .fontmsg {
    font-size: 12px;
  }

  .font12 {
    font-size: 12px;
  }

  .mfont14 {
    font-size: 14px
  }

  .brand {
    padding-top: 1rem;
    padding-bottom: 0.5rem;
    gap: 10px;
  }

  .logoblack {
    height: 56px;
  }

  .brand-name {
    font-size: 18px;
    letter-spacing: 0.22em;
  }

  .brand-en {
    font-size: 10px;
    letter-spacing: 0.28em;
  }

  .mmargintop20 {
    margin-top: 20px;
  }
}
</style>